import { useState } from 'react'
import { UploadedFile, useDeleteFile, useUploadFile } from '../data'
import { useErrorSnackbar } from 'shared/hooks'
export interface FeaturedImageProps {
  featuredImage: UploadedFile | undefined
  uploadFeaturedImage: (file: File) => Promise<void>
  isUploading: boolean
  deleteFeaturedImage: (fileId: string) => Promise<void>
  isDeleting: boolean
  clearFeaturedImage: () => Promise<void>
}

export interface useFeaturedImageProps {
  initialImage?: UploadedFile | undefined
}

export const useFeaturedImage = ({ initialImage = undefined }: useFeaturedImageProps = {}): FeaturedImageProps => {
  const [featuredImage, setFeaturedImage] = useState<UploadedFile | undefined>(initialImage)
  const [uploadFileMutation, { loading: isUploading }] = useUploadFile()
  const [deleteFileMutaion, { loading: isDeleting }] = useDeleteFile()
  const [showError] = useErrorSnackbar()

  const uploadFeaturedImage = async (file: File) => {
    try {
      const response = await uploadFileMutation({
        variables: {
          input: {
            file,
          },
        },
      })
      if (!response || !response.data) return
      const { file: uploadedFile } = response.data.uploadFile
      setFeaturedImage(uploadedFile)
    } catch (e) {
      showError()
    }
  }

  const deleteFeaturedImage = async (fileId: string) => {
    try {
      await deleteFileMutaion({
        variables: {
          input: {
            fileIds: [fileId],
          },
        },
      })
      setFeaturedImage(undefined)
    } catch (e) {
      showError()
    }
  }

  const clearFeaturedImage = async () => {
    if (!featuredImage) return
    try {
      await deleteFileMutaion({
        variables: {
          input: {
            fileIds: [featuredImage.id],
          },
        },
      })
      setFeaturedImage(undefined)
    } catch (e) {
      showError()
    }
  }

  return {
    featuredImage,
    uploadFeaturedImage,
    isUploading,
    deleteFeaturedImage,
    isDeleting,
    clearFeaturedImage,
  }
}
